export default __webpack_public_path__ + "static/media/ijeaomo.1b0f8bb3.png";